(function () {
  'use strict';

  var root = document.querySelector('[data-cc-photo-upload]');
  if (!root) return;

  var input = root.querySelector('[data-cc-photo-input]');
  var zone = root.querySelector('[data-cc-zone]');
  var emptyState = root.querySelector('[data-cc-zone-empty]');
  var previewState = root.querySelector('[data-cc-zone-preview]');
  var thumb = root.querySelector('[data-cc-photo-thumb]');
  var fileIcon = root.querySelector('[data-cc-photo-file-icon]');
  var nameEl = root.querySelector('[data-cc-photo-name]');
  var sizeEl = root.querySelector('[data-cc-photo-size]');
  var removeBtn = root.querySelector('[data-cc-photo-remove]');
  var errorEl = root.querySelector('[data-cc-photo-error]');
  var form = document.querySelector('[data-cc-product-form]');
  var atcBtn = document.querySelector('[data-cc-atc]');
  var atcText = document.querySelector('[data-cc-atc-text]');

  var label = root.dataset.label || 'Photo';
  var property = root.dataset.property || label;
  var required = root.hasAttribute('data-required');
  var maxMb = parseFloat(root.dataset.maxSizeMb) || 10;
  var maxBytes = maxMb * 1024 * 1024;
  var minW = parseInt(root.dataset.minWidth, 10) || 0;
  var minH = parseInt(root.dataset.minHeight, 10) || 0;
  var objectUrl = null;
  var currentFile = null;

  function dispatch() {
    document.dispatchEvent(new CustomEvent('cc:photo-changed', {
      detail: {
        property: property,
        label: label,
        filled: currentFile ? 1 : 0,
        min: 1,
        required: required,
        filename: currentFile ? currentFile.name : '',
        fileSize: currentFile ? currentFile.size : 0
      }
    }));
  }

  function setError(message) {
    if (errorEl) {
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }
    zone.classList.toggle('has-error', !!message);
  }

  function formatSize(bytes) {
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function revoke() {
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
      objectUrl = null;
    }
  }

  function showEmpty() {
    revoke();
    currentFile = null;
    emptyState.hidden = false;
    previewState.hidden = true;
    removeBtn.hidden = true;
    zone.classList.remove('has-file');
    dispatch();
  }

  function showPreview(file, imgOk) {
    currentFile = file;
    emptyState.hidden = true;
    previewState.hidden = false;
    removeBtn.hidden = false;
    zone.classList.add('has-file');
    nameEl.textContent = file.name;
    sizeEl.textContent = formatSize(file.size);
    thumb.hidden = !imgOk;
    fileIcon.hidden = imgOk;
    if (imgOk) thumb.src = objectUrl;
    dispatch();
  }

  // The accept attribute only filters the picker — drag-and-drop bypasses
  // it entirely, so every file validates here. Extension fallback catches
  // HEIC and friends whose MIME type some browsers leave empty.
  function isAcceptedType(file) {
    if (file.type && file.type.indexOf('image/') === 0) return true;
    return /\.(jpe?g|png|heic|heif|webp|gif)$/i.test(file.name);
  }

  function handleFile(file) {
    setError('');

    if (!isAcceptedType(file)) {
      input.value = '';
      showEmpty();
      setError('Please upload a JPG, PNG, or HEIC file.');
      return;
    }

    if (file.size > maxBytes) {
      input.value = '';
      showEmpty();
      setError('File is too large. Maximum size is ' + maxMb + ' MB.');
      return;
    }

    revoke();
    objectUrl = URL.createObjectURL(file);

    var probe = new Image();
    probe.onload = function () {
      if (minW && minH && (probe.naturalWidth < minW || probe.naturalHeight < minH)) {
        input.value = '';
        showEmpty();
        setError('Image is too small. Please upload an image at least ' + minW + '×' + minH + 'px.');
        return;
      }
      showPreview(file, true);
    };
    probe.onerror = function () {
      // HEIC (and friends) won't decode outside Safari — Shopify accepts
      // the upload fine. Skip the dimension check, show the file icon.
      showPreview(file, false);
    };
    probe.src = objectUrl;
  }

  input.addEventListener('change', function () {
    if (this.files && this.files[0]) {
      handleFile(this.files[0]);
    } else {
      showEmpty();
    }
  });

  // Gold highlight while dragging — the drop itself lands natively on the
  // full-coverage input, which fires change like any other selection.
  ['dragenter', 'dragover'].forEach(function (evt) {
    zone.addEventListener(evt, function () {
      zone.classList.add('is-dragover');
    });
  });
  ['dragleave', 'drop'].forEach(function (evt) {
    zone.addEventListener(evt, function () {
      zone.classList.remove('is-dragover');
    });
  });

  removeBtn.addEventListener('click', function () {
    input.value = '';
    setError('');
    showEmpty();
  });

  // Light submit guard: a 10MB file takes seconds on 4G. Disable AFTER the
  // submit dispatch completes so the button's value still posts.
  if (form) {
    form.addEventListener('submit', function () {
      if (currentFile && atcBtn && !atcBtn.disabled) {
        if (atcText) atcText.textContent = 'ADDING...';
        setTimeout(function () { atcBtn.disabled = true; }, 0);
      }
    });
  }

  // ATC is now AJAX (cc-atc-drawer.js) — no page navigation resets the
  // button, so re-enable when the cart broadcasts the add. 'cart:update'
  // is CartAddEvent.eventName in Atelier's @theme/events.
  document.addEventListener('cart:update', function () {
    if (atcBtn && atcText && atcText.textContent === 'ADDING...') {
      atcBtn.disabled = false;
      atcText.textContent = 'ADD TO CART';
    }
  });

  dispatch();
})();
